import { Box, Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface IButtonContainerProps {
  variant: 'teal' | 'green';
  title: string;
  description: string;
  ButtonComponent: React.ReactNode;
}

const variantStyles = {
  teal: {
    background: 'linear-gradient(135deg, #2A6C7E 0%, #2F7A8D 50%, #348A9E 100%)',
  },
  green: {
    background: 'linear-gradient(135deg, #028A7E 0%, #01D1BB 100%)',
  },
};

export const ButtonContainer = ({
  variant,
  title,
  description,
  ButtonComponent,
}: IButtonContainerProps) => {
  const styles = variantStyles[variant];

  return (
    <Box
      background={styles.background}
      borderRadius={25}
      paddingHorizontal={26}
      paddingTop={20}
      paddingBottom={26}
      boxShadow="2px 6px 16px 0 rgba(0, 0, 0, 0.16)"
      gap={6}
      flex={1}
    >
      <Text color={Colors.white} fontSize={24} bold>
        {title}
      </Text>
      <Row alignItems="flex-start" justifyContent="space-between" gap={17}>
        <Text color={Colors.white} flex={1}>
          {description}
        </Text>
        {ButtonComponent}
      </Row>
    </Box>
  );
};
